import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import gameReducer from '../features/game/gameSlice';

const LOCAL_STORAGE_KEY = "bigon-game-state-v0";

const getPersistedState = () => {
  const persistedStateString = localStorage.getItem(LOCAL_STORAGE_KEY);
  if ( ! persistedStateString ) {
    return undefined
  }
  try {
    const globalState = JSON.parse(persistedStateString);
    if (globalState?.game) {
      delete globalState.game.chosenTile;
      delete globalState.game.hoveredTile;
    }
    return globalState;
  } catch (err) {
    console.warn(err);
    return undefined
  }
}

export const store = configureStore({
  reducer: {
    game: gameReducer,
  },
  preloadedState: getPersistedState(),
});

store.subscribe(() => {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(store.getState()));
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
